"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = require("satcheljs/lib/legacy");
var store_1 = require("../store/store");
exports.default = legacy_1.action('deactivateCharm')(legacy_1.select({
    store: function () { return store_1.store; },
})(function deactivateCharm(charm, state) {
    if (state.store.activeCharm === charm) {
        state.store.activeCharm = null;
    }
}));
//# sourceMappingURL=deactivateCharm.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/header/owa-header-store/lib/actions/deactivateCharm.js
// module id = 1625
// module chunks = 2 87 105 106 107